import { I18N_LOCALE_KEY, I18N_REGION_KEY } from "./globals.js";

export type I18nHydrationScriptProps = {
  locale: string;
  region: string;
};

export function I18nHydrationScript(props: I18nHydrationScriptProps) {
  return (
    <script
      id={"i18n-hydration-script"}
      dangerouslySetInnerHTML={{
        __html: [
          `window["${I18N_LOCALE_KEY}"]="${props.locale}"`,
          `window["${I18N_REGION_KEY}"]="${props.region}"`,
        ].join(";"),
      }}
    />
  );
}
